import CouponList from '@/views/mobile/CouponList/index'

// 定义路由路径数列表
export default [{
  path: '/couponList',
  name: '优惠劵列表',
  component: CouponList
}]



// WEBPACK FOOTER //
// ./src/views/mobile/CouponList/routers/index.js